// npm
import React, { useState } from 'react';
import styled from 'styled-components';

// components
import Choice from './choice';

// flags
import PagSeguro from './img/pagseguro.png';
import PayPal from './img/paypal.png';

// choices
const choices = Object.values({
	0: {
		id: 'brasil',
		title: 'Plano Brasil - Standard',
		Flag: PagSeguro,
		text: 'Brasil',
		form: {
			action: 'https://pagseguro.uol.com.br/checkout/v2/payment.html',
			fields: {
				code: '896C89F0F0F0F59664732F904D292FC0',
				iot: 'button',
			},
			button: 'Pagar',
		},
	},
	/*1: {
		id: 'brasil-2',
		title: 'Plano Brasil - Express',
		Flag: PagSeguro,
		text: 'Brasil',
		form: {},
	},*/
	2: {
		id: 'international',
		title: 'International Plan',
		Flag: PayPal,
		text: 'International',
		form: {
			action: 'https://www.paypal.com/cgi-bin/webscr',
			fields: {
				cmd: '_s-xclick',
				encrypted: '-----BEGIN PKCS7-----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-----END PKCS7-----',
			},
			button: 'Pay',
		},
	},
});

// style
class Style {
	static Box = styled.div`
		flex: 0 0 auto;

		background: rgba(255, 255, 255, 1);
		border-radius: 1rem;
		flex-flow: column;
		max-width: 42rem;
		padding: 2rem 0;
		margin: 0 auto;
		display: flex;
		width: 90%;
	`;

	static Title = styled.div`
		text-align: center;
		font-weight: 700;
		font-size: 2rem;
		margin: 1.5rem;
	`;

	static Choices = styled.div`
		text-align: center;
		display: block;
	`;

	static Form = styled.form`
		flex-flow: column;
		margin: 1.5rem;
		display: flex;
	`;

	static Submit = styled.button`
		color: rgba(255, 255, 255, 1);
		background: rgb(0, 204, 153);
		text-transform: uppercase;
		letter-spacing: 0.125rem;
		border-radius: 1rem;
		font-weight: 700;
		max-width: 10rem;
		display: block;
		margin: 0 auto;
		height: 3rem;
		width: 100%;
	`;
}

// default
export default () => {
	const [selected, setSelected] = useState(choices[0].id);

	const choice = choices.find(a => a.id === selected);

	return (
		<Style.Box>
			<Style.Title children={choice.title} />

			<Style.Choices
				children={choices.map(item => (
					<Choice key={item.id} selected={item.id === selected} onClick={() => setSelected(item.id)} {...item} />
				))}
			/>

			<Style.Form action={choice.form.action} type='POST'>
				{Object.entries(choice.form.fields).map(([key, value]) => (
					<input key={key} type='hidden' name={key} value={value} />
				))}

				<Style.Submit children={choice.form.button} />
			</Style.Form>
		</Style.Box>
	);
};
